import {
  elemAttrForAnalytics,
  APPLE,
  FACEBOOK,
  GOOGLE,
  AnalyticsFieldsTypes
} from '@strava/authentication-ui';

export const useExtAuthBtnClickHandler = ({
  appleSignin,
  authorizationUrls,
  track
}: {
  appleSignin: () => void;
  authorizationUrls: {
    google: string;
    facebook: string;
  };
  track: (fields: AnalyticsFieldsTypes) => void;
}) => {
  /**
   * Facebook, Google, & Apple signup buttons onClick handler
   * Apple sign in uses function provided by Apple web sdk to handle sign in, FB & Google
   * sign ins use url provided by server
   */
  const handleExtAuthBtnClick = (
    option: typeof FACEBOOK | typeof GOOGLE | typeof APPLE
  ) => {
    const element = elemAttrForAnalytics(option);
    track({
      action: 'click',
      element
    });
    track({
      action: 'redirect',
      element,
      properties: {
        // no redirect url for Apple, so send `null` instead
        redirect_url: option === APPLE ? null : authorizationUrls[option],
        path_type: 'external_partner'
      }
    });

    if (option === APPLE) {
      appleSignin();
    } else {
      window.location.assign(authorizationUrls[option]);
    }
  };

  return { handleExtAuthBtnClick };
};
